import calculateTabService from '@services/requests/calculate-tab.service';
import { prepareState } from '@reducers/web-services/calculate/actions';
import { callErrorNotification } from '@components/Notification';
import { DISTANCE, AREA, STRENGTH, LOAD, MOMENT, TEMPERATURE, WEIGHT } from '@reducers/units';
import { isICCorCSA, prepareNum, unitTransform } from '@services/helper.service';
import { defaultUnits } from '@config';

export function generateReportGr (productIdx, diameterIdx, typeIdx, nailProductIdx, nailDiameterIdx, nailTypeIdx, rebarName, isDefault) {
    return (dispatch, getState) => {
      const state = getState();
      let selectedItem = state.selectors.calculate[state.main.appType].gridSelectedItem;
      var now = new Date();
      var dd = String(now.getDate()).padStart(2, '0');
      var mm = String(now.getMonth() + 1).padStart(2, '0'); 
      var yyyy = now.getFullYear();
      // var hour = String(now.getHours()).padStart(2, '0');
      // var min = String(now.getMinutes()).padStart(2, '0');
      var reportName = "Report.pdf";
      if (selectedItem.AnchorProduct)
      {
        var diameter = "";
        if (selectedItem.AnchorDiameter)
        {
          diameter = "_";
          if (isICCorCSA(state.main.localization.designStandard))
          {
            diameter += unitTransform(selectedItem.AnchorDiameter)
                          .from(defaultUnits.DISTANCE)
                          .to(state.main.units.distance === DISTANCE.INCHES ? DISTANCE.FRACTIONAL_INCHES : state.main.units.distance);
          }
          else if (selectedItem.AnchorCode !== "BAR")
          {
            diameter += "M" + prepareNum(selectedItem.AnchorDiameter, false);
          }
          else 
          {
            diameter += prepareNum(selectedItem.AnchorDiameter, false);
          }
        }
        
        reportName = selectedItem.AnchorProduct.replace(/\s/g, "_") + diameter +  "-" + dd + "_" + mm + "_" + yyyy  + ".pdf";
      }
      else if (selectedItem.DisplayName) // rebar
        reportName = selectedItem.DisplayName.replace(/\s/g, "_") + "-" + dd + "_" + mm + "_" + yyyy  + ".pdf";

      return calculateTabService.generateReportGr(prepareState(state), 
          "PDF", 
          productIdx, 
          diameterIdx, 
          typeIdx,
          nailProductIdx,
          nailDiameterIdx,
          nailTypeIdx,
          rebarName,
          isDefault,
          state.selectors.calculate.report)
          .then(res => {
            if (res.Message) {
              callErrorNotification(res.Message);
            }
            else {
              var newBlob = res.slice(0, res.size, "application/pdf");
              // save/display file
  
              // IE doesn't allow using a blob object directly as link href
              // instead it is necessary to use msSaveOrOpenBlob
              if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveOrOpenBlob(newBlob, reportName);
              } 
              else {
                // For other browsers: 
                // Create a link pointing to the ObjectURL containing the blob.
                const data = window.URL.createObjectURL(newBlob);
                var downloadLink = document.createElement("a");
                downloadLink.href = data;
                downloadLink.download = reportName;

                document.body.appendChild(downloadLink);
                downloadLink.click();
                document.body.removeChild(downloadLink);

                setTimeout(function(){
                  window.URL.revokeObjectURL(data);
                }, 300000); // revoke after 5 min
              }
            }
  
            return res;
          });
    };
  }

  export function updateClientUnits () {
    return (dispatch, getState) => {
      const state = getState();
      var units = [];
      switch (state.main.units.distance){
        case DISTANCE.CENTIMETERS: { units[0] = 1; break; }
        case DISTANCE.INCHES: { units[0] = 2; break; }
        default: { units[0] = 0; break; }
      }
      switch (state.main.units.area){
        case AREA.SQUARE_CENTIMETERS: { units[1] = 1; break; }
        case AREA.SQUARE_INCHES: { units[1] = 2; break; }
        default: { units[1] = 0; break; }
      }
      switch (state.main.units.strength){
        case STRENGTH.POUND_PER_SQUARE_INCH: { units[2] = 1; break; }
        default: { units[2] = 0; break; }
      }
      switch (state.main.units.load){
        case LOAD.NEWTON: { units[3] = 0; break; }
        case LOAD.DECANEWTON: { units[3] = 1; break; }
        case LOAD.POUND_FORCE: { units[3] = 3; break; }
        default: { units[3] = 4; break; }
      }
      switch (state.main.units.moment){
        case MOMENT.NEWTON_METERS: { units[4] = 0; break; }
        case MOMENT.DECANEWTON_METER: { units[4] = 1; break; }
        case MOMENT.FOOT_POUND_FORCE: { units[4] = 3; break; }
        default: { units[4] = 4; break; }
      }
      switch (state.main.units.temperature){
        case TEMPERATURE.FAHRENHEIT: { units[5] = 1; break; }
        default: { units[5] = 0; break; }
      }
      switch (state.main.units.weight){
        case WEIGHT.GRAM: { units[6] = 1; break; }
        case WEIGHT.POUND: { units[6] = 2; break; }
        default: { units[6] = 0; break; }
      }

      return calculateTabService.updateClientUnits(units); //.then();
    };
  }




// WEBPACK FOOTER //
// ./src/reducers/web-services/report/actions.js